module.exports = __webpack_public_path__ + "img/aufgabe_alt_1.154bfaba.png";